/* eslint-disable react-native/no-inline-styles */
import {useNavigation} from '@react-navigation/core';
import {
  Avatar,
  Button,
  Divider,
  Icon,
  Layout,
  Text,
} from '@ui-kitten/components';
// import moment from 'moment';
import React from 'react';
import {
  Linking,
  Platform,
  ScrollView,
  StyleSheet,
  TouchableOpacity,
  View,
} from 'react-native';
import {getVersion} from 'react-native-device-info';
import {useDispatch, useSelector} from 'react-redux';
// import {getCheckTrialStatus} from '../../apis';
// import themeColors from '../../assets/json/custom-theme.json';
import {getImage} from '../../helpers/general';
import {
  DRAWER_ROUTES,
  UN_AUTHENTICATED_ROUTES,
} from '../../navigation/constants';
import {signOut} from '../../redux/actions/auth';
import {isLandscape, px} from '../../utils';

const Header = (props) => {
  const navigation = useNavigation();
  const user = useSelector((state) => state.auth.user);
  const kids = useSelector((state) => state.general.kids);
  const {kidsImage = ''} = kids?.[0] || {};

  return (
    <Layout style={{backgroundColor: 'transparent'}}>
      <TouchableOpacity
        onPress={() => navigation.navigate(DRAWER_ROUTES.settings.path)}>
        <Layout style={styles.headerContent}>
          <Avatar
            style={styles.avatar}
            source={{uri: kidsImage ? getImage(kidsImage) : ''}}
          />
          <View style={styles.userInformation}>
            <Text category="h6" style={styles.headerFullName}>
              {user?.fullName || ''}
            </Text>
            <Text style={styles.headerLightText}>{user?.gradeName || ''}</Text>
          </View>
        </Layout>
      </TouchableOpacity>
    </Layout>
  );
};

const HomeIcon = (props) => <Icon {...props} name="home-outline" />;
const ClassroomIcon = (props) => <Icon {...props} name="calendar-outline" />;
const InboxIcon = ({showBadge, ...otherProps}) => {
  return (
    <View style={styles.iconWithBadgeContainer}>
      {showBadge && <View style={styles.badge} />}
      <Icon {...otherProps} name="bell-outline" />
    </View>
  );
};
const CheckMarkIcon = (props) => (
  <Icon {...props} name="checkmark-circle-2-outline" />
);
const PeopleIcon = (props) => <Icon {...props} name="people-outline" />;
const MonitorIcon = (props) => <Icon {...props} name="monitor-outline" />;
// const MessageIcon = (props) => (
//   <Icon {...props} name="message-square-outline" />
// );
const FileIcon = (props) => <Icon {...props} name="file-text-outline" />;
const SettingsIcon = (props) => <Icon {...props} name="settings-2-outline" />;
const PhoneIcon = (props) => <Icon {...props} name="phone-outline" />;
const QuestionIcon = (props) => (
  <Icon {...props} name="question-mark-circle-outline" />
);
const CloseIcon = (props) => <Icon {...props} name="close-circle-outline" />;

const DrawerButton = ({
  isSelected,
  onPress,
  route,
  icon,
  title,
  navigation,
}) => (
  <Button
    appearance={isSelected ? 'filled' : 'ghost'}
    status={isSelected ? 'warning' : 'basic'}
    onPress={() => {
      if (onPress) {
        onPress();
      } else {
        navigation.navigate(route);
      }
    }}
    style={[
      styles.drawerItem,
      isSelected ? {backgroundColor: '#FFD7CA', borderColor: '#FFD7CA'} : {},
    ]}
    accessoryLeft={(evaProps) =>
      icon({
        ...evaProps,
        fill: isSelected ? '#FF5722' : '#757575',
      })
    }>
    {(evaProps) => (
      <Text
        {...evaProps}
        style={[evaProps.style, {color: isSelected ? '#FF5722' : 'black'}]}>
        {title}
      </Text>
    )}
  </Button>
);

const DrawerContent = ({navigation}) => {
  const haveNewNotif = useSelector((state) => state.inbox.haveNewNotif);

  const dispatch = useDispatch();

  const routes = [
    {
      title: 'Home',
      icon: HomeIcon,
      route: DRAWER_ROUTES.home.path,
    },
    {
      title: 'Buy/Renew Subscription',
      icon: CheckMarkIcon,
      route: DRAWER_ROUTES.subscription.path,
    },
    {
      title: 'Teachers & Subjects',
      icon: PeopleIcon,
      route: DRAWER_ROUTES.subjects.path,
    },
    {
      title: 'Join Classroom',
      icon: MonitorIcon,
      route: DRAWER_ROUTES.classroom.path,
    },
    {
      title: 'Timetable',
      icon: ClassroomIcon,
      route: DRAWER_ROUTES.timeTable.path,
    },
    {
      title: 'Announcement',
      icon: (props) => <InboxIcon {...props} showBadge={haveNewNotif} />,
      route: DRAWER_ROUTES.inbox.path,
    },
    // {
    //   title: 'Telegram Groups',
    //   icon: MessageIcon,
    //   onPress: () => {},
    // },
    {
      title: 'Payment History',
      icon: FileIcon,
      route: DRAWER_ROUTES.paymentHistory.path,
    },
    {
      title: 'Setting',
      icon: SettingsIcon,
      route: DRAWER_ROUTES.settings.path,
    },
    {
      title: 'Contact Us',
      icon: PhoneIcon,
      route: DRAWER_ROUTES.contactUs.path,
    },
    {
      title: "New Student's Guide",
      icon: QuestionIcon,
      onPress: () => {
        Linking.openURL('https://linktr.ee/startutorstudentguide');
      },
      //route: DRAWER_ROUTES.videoHelpPage.path,
    },
  ];

  const navState = navigation.dangerouslyGetState();
  const currentRouteName = navState?.routes?.[navState.index]?.name;

  const appVersion = getVersion();

  return (
    <Layout style={styles.drawerWrapper}>
      <Header />
      <ScrollView contentContainerStyle={styles.drawer}>
        <View>
          {routes.map(({icon, title, onPress, route}) => (
            <DrawerButton
              isSelected={currentRouteName === route}
              key={title}
              icon={icon}
              navigation={navigation}
              onPress={onPress}
              route={route}
              title={title}
            />
          ))}
        </View>
        <View>
          {Platform.OS !== 'web' && (
            <Text style={styles.versionText}>{`v ${appVersion}`}</Text>
          )}
          <Divider />
          <DrawerButton
            icon={CloseIcon}
            navigation={navigation}
            onPress={() => {
              setTimeout(() => {
                dispatch(signOut());
              }, 500);
              navigation.navigate(UN_AUTHENTICATED_ROUTES.signIn.path);
            }}
            title="Log Out"
          />
        </View>
      </ScrollView>
    </Layout>
  );
};

const styles = StyleSheet.create({
  headerContent: {
    backgroundColor: '#FF5722',
    paddingLeft: 16,
    paddingTop: isLandscape() ? 66 : 26,
    paddingBottom: 12,
    justifyContent: 'center',
    flexDirection: 'row',
  },
  avatar: {
    width: px(64),
    height: px(64),
    maxWidth: px(64),
    maxHeight: px(64),
    backgroundColor: '#FFEDEF',
    flex: 1,
  },
  userInformation: {
    flex: 2,
    paddingLeft: 10,
  },
  headerFullName: {
    color: 'white',
    fontWeight: '700',
    fontSize: 16,
    marginTop: px(10),
    marginBottom: px(5),
  },
  headerLightText: {
    color: 'white',
    fontWeight: '500',
    marginBottom: px(5),
    fontSize: 14,
  },
  drawerWrapper: {
    flexDirection: 'column',
    height: '100%',
  },
  drawer: {
    paddingTop: 15,
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  drawerItem: {
    borderRadius: 0,
    justifyContent: 'flex-start',
  },
  iconWithBadgeContainer: {
    position: 'relative',
    top: 0,
  },
  badge: {
    position: 'relative',
    backgroundColor: '#f00',
    width: px(10),
    height: px(10),
    top: 8,
    right: -7,
    zIndex: 1,
    borderRadius: px(100),
  },
  versionText: {
    marginBottom: 10,
    fontSize: px(12),
    width: '100%',
    textAlign: 'center',
  },
});

export default DrawerContent;
